import React from 'react';

function Cell(props) {
  function handleClick(e) {
    props.clickHandler(props.index);
    e.preventDefault();
  }
  /*<p className="cell-tag">{props.index}</p> */
  if (parseInt(props.data) === -1) {
    return (
      <div className={'board-cell-dead'}>
        <p className="cell-data"> </p>
      </div>
    );
  } else {
    return (
      <div onClick={handleClick} className="board-cell">
        <p
          className={
            props.hotCell === props.index ? 'cell-data-hot' : 'cell-data'
          }
        >
          {' '}
          {props.data !== 0 ? '\u25CF' : ''}{' '}
        </p>
      </div>
    );
  }
}

export default Cell;
